import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MenuWidget } from '../models/menu-widget.model';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private menuItemSubject = new BehaviorSubject<MenuWidget | null>(null);
  private menuItemsSubject = new BehaviorSubject<MenuWidget[] | null>(null);

  menuItem$ = this.menuItemSubject.asObservable();
  menuItems$ = this.menuItemsSubject.asObservable();

  emitMenuItem(item: MenuWidget | null): void {
    this.menuItemSubject.next(item);
  }

  emitMenuItems(items: MenuWidget[] | null): void {
    this.menuItemsSubject.next(items);
  }

  getLastMenuItem(): MenuWidget | null {
    return this.menuItemSubject.getValue();
  }

  getLastMenuItems(): MenuWidget[] | null {
    return this.menuItemsSubject.getValue();
  }

}
